import { render } from "./LevelButton.vue?vue&type=template&id=c06b6176&scoped=true&ts=true"
import script from "./LevelButton.vue?vue&type=script&lang=ts"
export * from "./LevelButton.vue?vue&type=script&lang=ts"

import "./LevelButton.vue?vue&type=style&index=0&id=c06b6176&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06b6176"]])

export default __exports__